import { Common } from './common';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async checkExistenceByPrevisit(
    previsitFormSetId: string,
  ): Promise<{ exists: boolean }> {
    // uses built-in auth to find valid SSN, if any
    const url = this.common.constructPath(`/patient-previsit/ssn`, {
      previsitFormSetId,
    });
    return this.common.getJSON(url);
  }

  async checkExistenceByPatient(
    patientId: string,
  ): Promise<{ exists: boolean }> {
    const url = this.common.constructPath(`/patient-ssns/${patientId}/exists`);
    return this.common.getJSON(url);
  }

  async getSsn4(patientId: string): Promise<{ ssn4: string }> {
    const url = this.common.constructPath(`/patient-ssns/${patientId}/ssn4`);
    return this.common.getJSON(url);
  }

  async upsert(
    ssn: string,
    previsitFormSetId: string,
  ): Promise<{ success: boolean }> {
    const url = this.common.constructPath(`/patient-previsit/ssn`);
    return this.common.postJSON(url, { ssn, previsitFormSetId });
  }
}
